/*  MUI  */
import { TableCell } from '@mui/material';

/*  Shared  */
import { ApplicationNameLinkCell } from 'application/Shared/Components/ApplicationNameLinkCell';
import { DateFormat } from 'application/Shared/Components/Core';
import { ManagedTable } from 'application/Shared/Components/Table';
import { Helpers } from 'application/Shared/Helpers';

/* Yarn */
import equal from 'fast-deep-equal';

/*  Objects  */
import { Application } from 'objects/Application';
import { Tenant, TenantName } from 'objects/Tenant';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

/*  Constants  */
const searchFields = [
    'dateCreated',
    'eventName',
    'resourceName',
    'application.name',
    'tenant.name'
];

class History extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: null,
            parameters: null
        };
    }

    componentDidMount() {
        this.setState({ headers: this.renderHeaders() });
        this.handleExtraParameters();
    }

    componentDidUpdate(prevProps) {
        const { dateSearch } = this.props;
        if (!equal(dateSearch, prevProps.dateSearch)) {
            this.handleExtraParameters();
        }
    }

    handleExtraParameters = () => {
        const { partner, dateSearch } = this.props;
        const currentExtraParameters = { size: -1 };

        if (partner) {
            currentExtraParameters.includeClients = true;
            currentExtraParameters.includeTenant = true;
        }

        if (dateSearch) {
            currentExtraParameters[dateSearch.key] = dateSearch.value;
        }

        this.setState({
            parameters: currentExtraParameters
        });
    };

    renderHeaders = () => {
        const { t, partner } = this.props;

        const headers = [
            {
                field: 'dateCreated',
                renderHeader: t('Common.timestamp'),
                width: '20%'
            },
            {
                field: 'event',
                renderHeader: t('Alert.triggered'),
                width: '20%'
            },
            {
                field: 'resource',
                renderHeader: t('Alert.object_involved'),
                width: `${partner ? '10%' : '25%'}`
            },
            {
                field: 'workflowAffectedApp',
                renderHeader: t('Alert.affected_app'),
                width: `${partner ? '25%' : '35%'}`
            }
        ];

        if (partner) {
            headers.push({
                field: 'client',
                renderHeader: t('Common.client'),
                width: '25%'
            });
        }

        return headers;
    };

    renderApplication = (application) => {
        const { match } = this.props;
        const { clientId, partnerId } = match.params;

        return (
            <Application
                data={application}
                {...(clientId
                    ? { nameHasLink: true }
                    : {
                          nameLinkTo: `/partner/${partnerId}/applicationSettings`
                      })}
            >
                <ApplicationNameLinkCell withCategory />
            </Application>
        );
    };

    renderDeletedText = () => {
        const { t } = this.props;
        return <span>{t('Alert.removed')}</span>;
    };

    handlePreprocessRows = (rows) => {
        const { resources } = this.props;

        return rows.map((row) => {
            const { resource } = row;

            // Convert resource key to the resource display name for searching
            let resourceName = resource;
            if (Helpers.isset(resources, resource, 'name')) {
                resourceName = resources[resource].name;
            }

            return {
                ...row,
                resourceName
            };
        });
    };

    renderRow = (row) => {
        const { partner, resources } = this.props;
        const { dateCreated, eventName, resource, application, tenant } = row;

        let resourceName = resource;
        if (Helpers.isset(resources, resource, 'name')) {
            resourceName = resources[resource].name;
        }

        return (
            <>
                <TableCell>
                    <DateFormat date={dateCreated} />
                </TableCell>
                <TableCell>{eventName || this.renderDeletedText()}</TableCell>
                <TableCell>{resourceName}</TableCell>
                <TableCell>
                    {application && this.renderApplication(application)}
                </TableCell>
                {partner && (
                    <TableCell>
                        <Tenant data={tenant}>
                            <div style={{ width: '100%' }}>
                                <TenantName />
                            </div>
                        </Tenant>
                    </TableCell>
                )}
            </>
        );
    };

    render() {
        const { parameters, headers } = this.state;

        return (
            <ManagedTable
                headers={headers}
                parameters={parameters}
                renderBody={this.renderRow}
                renderBodyKey="id"
                renderFooter
                rowsApi="/workflowHistory"
                rowsApiPreload
                rowsPerPage={10}
                searchEnabled
                searchFields={searchFields}
                sortDirection="DESC"
                sortFieldType="date"
                sortKey="dateCreated"
                preprocessRows={this.handlePreprocessRows}
            />
        );
    }
}

export default withRouter(withTranslation()(History));
